import { render, staticRenderFns } from "./FilterCreatorLanguageInput.vue?vue&type=template&id=5c235726&scoped=true&"
import script from "./FilterCreatorLanguageInput.vue?vue&type=script&lang=ts&"
export * from "./FilterCreatorLanguageInput.vue?vue&type=script&lang=ts&"
import style0 from "./FilterCreatorLanguageInput.vue?vue&type=style&index=0&id=5c235726&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c235726",
  null
  
)

export default component.exports